export const iconFontAwesomeAutomotiveCarSide = (
	<i className="fa-solid fa-car-side"></i>
);
